export default "__VITE_ASSET__XKmcfOR$__"